import { createReducer, on } from '@ngrx/store';
import * as fromVoucherActions from '../actions/voucher.actions';

export const featureKey = 'voucher';

export interface State {
  vouchers: {
      data: any,
      isLoaded: Boolean
  };
}

export const initialState: State = {
  vouchers: {
      data: null,
      isLoaded: false
  },
};

export const reducer = createReducer(
  initialState,  
  on(fromVoucherActions.getVoucherListSuccess, (state: State, props: any) => ({
    ...state,
    vouchers: {data: props.data, isLoaded: true}
  })),
);
